<template>
  <div class="hello">
    lang ===>
    <div class="">
      {{lang}}
    </div>
    contents ===>
    <div class="">
      {{contents}}
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'HelloWorld',
  data () {
    return {
    }
  },
  computed: {
    state () {
      return this.$store.state
    },
    ...mapGetters(['lang', 'contents'])
  },
  methods: {
    ...mapActions(['increment'])
  },
  mounted: function () {
    // console.log(this.contents)
  },
  watch: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue